import { formatPhoneNumber, isValidPhoneNumber } from "@oekopunktemarkt/text/phone";

// The funnel and CRM must share the same validation and identity normalization.
export * from "@oekopunktemarkt/text/phone";

/** A dialable canonical phone number, or null when contact input is unusable. */
export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw?.trim()) return null;
  return isValidPhoneNumber(raw) ? formatPhoneNumber(raw) : null;
}
